// extracted by css-extract-rspack-plugin
export default {"desktop-wrapper":"DesktopWrapper_desktop-wrapper__cs8CX"};